import React from "react";
import PublicNavbar from "../../components/PublicNavbar";
import Footer from "../../components/Footer";

export default function LegalMentions() {
  return (
    <div className="min-h-screen bg-white">
      <PublicNavbar />
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16">
        <div className="overline">Informations légales</div>
        <h1 className="font-heading text-3xl sm:text-4xl font-medium tracking-tight text-slate-900 mt-2">
          Mentions légales
        </h1>
        <div className="text-xs text-slate-500 mt-1">Dernière mise à jour : 17 février 2026</div>

        <div className="prose prose-slate max-w-none mt-10 text-[15px] leading-relaxed space-y-8">
          <Section title="1. Éditeur du site">
            <p>
              Le site <strong>Junago</strong> est édité par la société <strong>Junago SAS</strong>,
              société par actions simplifiée au capital de 10 000 €,
              immatriculée au RCS de Paris sous le numéro 000 000 000,
              dont le siège social est situé 42 rue de la Mobilité, 75002 Paris, France.
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Numéro de TVA intracommunautaire : FR00 000000000</li>
              <li>Directeur de la publication : la représentante légale de Junago SAS</li>
              <li>Contact : <a className="text-violet-600 underline" href="mailto:contact@junago.fr">contact@junago.fr</a></li>
              <li>Téléphone : +33 (0)1 00 00 00 00</li>
            </ul>
          </Section>

          <Section title="2. Hébergement">
            <p>
              Le site est hébergé par <strong>Emergent Cloud</strong>, plateforme fournissant
              l'infrastructure de déploiement. Les données applicatives sont stockées en Europe.
            </p>
          </Section>

          <Section title="3. Objet de la plateforme">
            <p>
              Junago est un logiciel de gestion de flotte (SaaS) destiné aux loueurs de
              véhicules professionnels : gestion des véhicules, réservations, contrats,
              états des lieux et encaissements. Junago n'est pas propriétaire des véhicules
              gérés via le logiciel et n'exerce pas directement d'activité de location.
            </p>
          </Section>

          <Section title="4. Propriété intellectuelle">
            <p>
              L'ensemble des contenus présents sur le site (marque Junago, logo, textes,
              illustrations, structure de la plateforme) est protégé par le droit d'auteur et le
              droit des marques. Toute reproduction, représentation ou diffusion, totale ou
              partielle, est interdite sans autorisation écrite préalable.
            </p>
          </Section>

          <Section title="5. Responsabilité">
            <p>
              Junago s'efforce d'assurer la fiabilité des informations publiées sur la
              plateforme, mais ne peut garantir l'exactitude des informations fournies par les
              loueurs (photos, description, tarifs, disponibilité). Chaque loueur est
              responsable du contenu qu'il publie. Junago décline toute responsabilité en cas
              de litige entre un client et un loueur hors de son contrôle.
            </p>
          </Section>

          <Section title="6. Paiements">
            <p>
              Les paiements effectués via Junago sont traités par <strong>Stripe Payments Europe, Ltd</strong>.
              Junago n'a jamais accès aux données de carte bancaire de ses utilisateurs.
              Les montants encaissés sont reversés intégralement au loueur.
            </p>
          </Section>

          <Section title="7. Droit applicable">
            <p>
              Les présentes mentions légales sont soumises au droit français. Tout litige relatif
              à leur interprétation ou leur exécution relève de la compétence exclusive des
              tribunaux de Paris.
            </p>
          </Section>
        </div>
      </div>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-heading text-xl font-medium tracking-tight text-slate-900">{title}</h2>
      <div className="mt-3 text-slate-700 space-y-3">{children}</div>
    </section>
  );
}
